import axios from 'axios';

import store from '@/store';
import baseConfig from '_config';

const axiosInterceptor = () => {
  let exceptions = ['oauth/access_token'];

  exceptions = exceptions.map(e => `${baseConfig.API_URL}${e}`);

  // Add a request interceptor
  axios.interceptors.request.use(config => {
    if (!exceptions.includes(config.url)) {
      if (!store.state.toggle.progress) {
        store.dispatch('toggle', 'progress');
      }
    }
    return config;
  });

  // Add a response interceptor
  axios.interceptors.response.use(
    response => {
      if (!exceptions.includes(response.config.url)) {
        if (store.state.toggle.progress) {
          store.dispatch('toggle', 'progress');
        }
      }
      return response;
    },
    err => {
      // if the progress is set to true before
      // reset the state
      if (store.state.toggle.progress) {
        store.dispatch('toggle', 'progress');
      }

      return Promise.reject(err);
    },
  );
};

export default axiosInterceptor;
